export default "__VITE_ASSET__e7bfe6b6__"